import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "base-sidebar" }
const _hoisted_2 = { class: "close" }
const _hoisted_3 = { class: "content" }

import { onBeforeUnmount, onMounted, ref } from "vue";
import { baseLoading } from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'base-sidebar',
  props: {
    open: { type: Boolean, default: false },
    outsideClose: { type: Boolean, default: true },
    loading: { type: Boolean, default: false },
    width: { default: "50rem" }
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "ec02ce1e": (props.width)
}))

const props = __props;

const emit = __emit;

const internalOpen = ref(props.open);

function addHidePageScroll() {
  document.querySelector("html").classList.add("no-scroll");
}

function removeHidePageScroll() {
  document.querySelector("html").classList.remove("no-scroll");
}

function sidebarClose() {
  internalOpen.value = false;

  setTimeout(() => {
    emit("close");
  }, 350);
}

function sidebarOutsideClose() {
  if (props.outsideClose) sidebarClose();
}

onBeforeUnmount(() => {
  removeHidePageScroll();
});

onMounted(() => {
  addHidePageScroll();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("article", _hoisted_1, [
      _createElementVNode("div", {
        class: "outside",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (sidebarOutsideClose()))
      }),
      _createElementVNode("section", {
        class: _normalizeClass(["sidebar", {
					'slide-left': props.open && internalOpen.value,
					'slide-right': !internalOpen.value,
				}])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "btn btn-default",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (sidebarClose()))
          }, "x")
        ]),
        _createElementVNode("div", _hoisted_3, [
          (props.loading)
            ? (_openBlock(), _createBlock(_unref(baseLoading), { key: 0 }))
            : _renderSlot(_ctx.$slots, "default", {}, undefined, undefined, 1)
        ])
      ], 2)
    ])
  ]))
}
}

})